<template>
  <svg fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
       width="5.865"
       height="10.001"
       viewBox="0 0 5.865 10.001"
  >
    <path id="Path_773"
          data-name="Path 773"
          d="M2.931,0A2.888,2.888,0,0,0,0,3,6.043,6.043,0,0,0,.6,5.134L2.613,9.789h0a.345.345,0,0,0,.636,0l2.01-4.655A6.046,6.046,0,0,0,5.861,3a2.888,2.888,0,0,0-2.93-3Zm0,1.724A1.207,1.207,0,1,1,1.724,2.931,1.207,1.207,0,0,1,2.931,1.724"
          transform="translate(0.002 0)"
    />
  </svg>
</template>

<script>
export default {
  name: "LocationIcon"
}
</script>
